import { useEffect } from "react";

// Vuelve a consultar cuando el usuario regresa a la pestana o a la ventana.
export default function useRefetchOnFocus(refetch, enabled = true) {
  useEffect(() => {
    if (!enabled || !refetch) {
      return undefined;
    }

    const refreshData = () => {
      refetch();
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        refreshData();
      }
    };

    window.addEventListener("focus", refreshData);
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      window.removeEventListener("focus", refreshData);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, [enabled, refetch]);
}
